module.exports = __webpack_public_path__ + "img/mc173.bc690505.jpg";